import {axios} from '../utils/request'
import router from '../router/index'
import {loopMenuList} from '../utils/ecp'
import Vue from 'vue'
import {v4 as uuid} from "uuid";
import {refreshToken} from "./login";

// 获取字典表
export function getDictByType(dictType) {
  return new Promise((resolve, reject) => {
    pbService('service.core.sysdicinfoService', 'getDictInfoByTypeCache', {
      dictType, result_fields: '', order_expr: ''
    }).then(res => {
      if (res && res.resultset) {
        resolve(res.resultset.map(o => ({value: o.sysdic_code, label: o.sysdic_name})))
      } else {
        resolve([])
      }
    }, err => {
      reject(err)
    })
  })
}

export function appLoad(account, org_uuid) {
  return new Promise((resolve, reject) => {
    pbService('service.pf.menuService', 'getAccountAppExt', {
      accountid: account,
      org_uuid: org_uuid
    }).then(res => {
      // 菜单列表转换成树结构菜单数据
      if (res && res.resultset) {
        resolve(res.resultset)
      } else {
        resolve([])
      }
    }, err => {
      reject(err)
    })
  })
}

export function menuLoad(app, account, dept, manageunit) {
  return new Promise((resolve, reject) => {
    pbService('service.pf.menuService', 'menu_load', {
      jsu: {
        appuuid: app, account_id: account, deptuuid: dept, manageunituuid: manageunit
      }
    }).then(res => {
      // 菜单列表转换成树结构菜单数据
      resolve(loopMenuList(res.resultset, app ? app : Vue.prototype.$TREE_ROOT))
    }, err => {
      reject(err)
    })
  })
}

export function getAccountDepart(account) {
  return new Promise((resolve, reject) => {
    pbService('service.pf.menuService', 'getAccountDepart', {account_id: account}).then(res => {
      // 将当前部门和兼职部门合并后输出
      const pp = res.deptex.map(o => ({id: o.depart_uuid, name: o.depart_uuidname}))
      res.staff.depart_uuid && pp.unshift({id: res.staff.depart_uuid, name: res.staff.depart_uuidname})
      resolve(pp)
    }, err => {
      reject(err)
    })
  })
}

export function menuCode2RealUrl(menu) {
  return pbService('service.pf.menuService', 'menuCode2RealUrl', {menuid: menu})
}

// =====PackageService=====
/**
 * 应用包分页数据
 *
 * @param data 服务参数
 * @param params 请求参数
 * @return {Promise<{}>}
 */
export function getPackageList(data, params) {
  return pbService(
    'service.pf.packageService',
    'pageQueryPackageInfoByAttr',
    {package_info: data, resultfields: '', orderfields: ''},
    params)
}

export function getPackageById(id) {
  return pbService(
    'service.pf.packageService',
    'queryPackageInfoById',
    {pack_uuid: id, resultfields: ''})
}

/**
 *
 * 快捷菜单新增方法
 * @export
 * @param {accountId} 当前用户accoundId
 * @param {selectArray} 选中的数组
 * @returns
 */
export function addQuickList(accountId,selectArray) {
  console.log(accountId);
  return pbService(
    'service.pf.accountMenuService',
    'createOrUpdateAccountMenu',
    {
      'op_acc': accountId,
      'menu_info' : selectArray
    }
  )
}
/**
 *
 * 快捷菜单查询方法
 * @export
 * @param {acoundId} 当前用户accoundId
 */
export function queryQuickList(acoundId) {
  return pbService(
    'service.pf.accountMenuService',
    'queryAccountMenuByCond',
    {
      'op_acc' : acoundId
    }
  )
}

export function updatePackage(params, operator) {
  return pbService(
    'service.pf.packageService',
    'changePackage',
    {op_acc: operator, package_info: params})
}

export function addPackage(params, operator) {
  return pbService(
    'service.pf.packageService',
    'createPackage',
    {op_acc: operator, package_info: params})
}

export function deletePackage(id, operator) {
  return pbService(
    'service.pf.packageService',
    'deleltePackage',
    {op_acc: operator, pack_uuid: id})
}

export function getFunctionTreeByPackage(id, parent = '-1') {
  return pbService(
    'service.pf.packageService',
    'queryFunListByParentID',
    {pack_uuid: id, parent_uuid: parent, resultfields: '', orderfields: ''})
}

export function getFunctionById(id) {
  return pbService(
    'service.pf.packageService',
    'queryFunInfoByID',
    {func_uuid: id, resultfields: ''})
}

export function updateFunction(params, operator) {
  return pbService(
    'service.pf.packageService',
    'changeFun',
    {op_acc: operator, package_info: params})
}

export function addFunction(params, operator) {
  return pbService(
    'service.pf.packageService',
    'createFun',
    {op_acc: operator, packfunc_info: params})
}

export function deleteFunction(id, operator) {
  return pbService(
    'service.pf.packageService',
    'deleteFun',
    {op_acc: operator, func_uuid: id})
}

// 首页的表格
export function homeTableData() {
  return pbService(
    'service.wf.workFlowService',
    'pageQueryTodoInfoList'
  )
}

// 企业微信二维码登录地址
export function qrConnect() {
  return pbService(
    'service.qr.ecpQrcodeService',
    'getQrCodeContent',
    {
      "op_acc": 'sa',
      "configure_code": 'login_qywx_test', // TODO 前端配置
      "params": {}
    }
  )
}
/*var servername = 'service.egw.columnService';
            var servermethod = 'create' egw.service;
  */
export function pbService(name, method, data, params,headers) {
  // const type = process.env.NODE_ENV === 'production' ? 'text/plain' : 'application/json'
  const type = process.env.NODE_ENV === 'production' ? {'Content-Type':'text/plain'} : {'Content-Type':'application/json'}
  let url = '';

  if(name){
    const module = name.split(".")[1];
    url = `${module}/service`;
  }
  return axios.post(url, {
    SERVER_NAME: name,
    SERVER_METHOD: method,
    DATA: data
  }, {
    headers: Object.assign({},headers,type),
      params: params
  })
}

/**
 * 按钮审计公用方法
 * @param buttonName    按钮名称
 * @param result        操作结果-true：成功，false-失败
 * @param desc          按钮操作详细描述信息
 */
export function buttonAudit(buttonName,result,desc) {
  return pbService(
    'service.oauth.portalOAuthHandler',
    'createMenuAudit',
    {
      "target_type": '02',
      "target_info":{
          'target_name':buttonName
          ,'audit_result':result?'1':'0'
          ,'audit_desc':desc
      }
    }
  )
}

/**
 * 打开浏览器新窗口
 * @param path      url路径
 * @param target    打开方式-默认新开窗口，'_self'为本窗口打开
 * @param jparams   url参数
 */
export function openWin(path,target="_blank", jparams) {
  if (path.indexOf("http") == 0) {
    window.open(path,target);
  }else if (!Vue.ss.get('token') && Vue.ss.get('refresh_token')) {
    refreshToken(Vue.ss.get('refresh_token')).then(d => {
      Vue.ss.set('token', d.access_token, d.expires_in * 1000)
      Vue.ss.set('refresh_token', d.refresh_token, 3600 * 24 * 1000)
      setTimeout(()=>{
        const url = router.resolve({path:path,query:Object.assign({},jparams)});
        window.open(url.href,target);
      })
    });
  }else{
    const url = router.resolve({path:path,query:Object.assign({},jparams)});
    window.open(url.href,target);
  }
}

/**
 * 生产32位uuid
 */
export function getUUID(){
  return uuid().replace(/-/g,'').toUpperCase();
}
/**
 * 提示信息 info
 * @param type: 消息-info 提示-warning 成功-success 错误-error
 * @param title
 * @param content 可为空
 */
export function msg_tipsinfo(object,type,title,content='') {
  if("info"===type){
    object.$info({
      title: title,
      content: content
    });
  }else if("warning"===type){
    object.$warning({
      title: title,
      content: content
    });
  }else if("success"===type){
    object.$success({
      title: title,
      content: content
    });
  }else if("error"===type){
    object.$error({
      title: title,
      content: content
    });
  }else{
    object.$info({
      title: title,
      content: content
    });
  }
}
/**
 * 提示信息 info
 * @param title
 */
export function msg_simpinfo(object,content) {
  object.$info({
    title: content
  });
}
/**
 * 提示信息 success
 * @param title
 */
export function msg_simpsuccess(object,content) {
  object.$success({
    title: content
  });
}
/**
 * 提示信息 warning
 * @param title
 */
export function msg_simpwarning(object,content) {
  object.$warning({
    title: content
  });
}
/**
 * 提示信息 error
 * @param error
 */
export function msg_simperror(object,content) {
  object.$error({
    title: content
  });
}